// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fraction_type_enum_8f45884b */
var FractionTypeEnum8f45884b;
(function (FractionTypeEnum8f45884b) {
    FractionTypeEnum8f45884b["broth"] = "broth";
    FractionTypeEnum8f45884b["supernatant"] = "supernatant";
    FractionTypeEnum8f45884b["pellet"] = "pellet";
    FractionTypeEnum8f45884b["powder"] = "powder";
})(FractionTypeEnum8f45884b || (FractionTypeEnum8f45884b = {}));
;
export default FractionTypeEnum8f45884b;
/** Zod schema for fraction_type_enum_8f45884b */
export const fractionTypeEnum8f45884b = z.nativeEnum(FractionTypeEnum8f45884b);
//# sourceMappingURL=FractionTypeEnum8f45884b.js.map